import styled from 'styled-components';

import { CloseButton as CloseButtonBase } from 'components/buttons/close-button';

const MOBILE = '@media (max-width: 768px)';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.lg};
  z-index: 1000;

  ${MOBILE} {
    flex-direction: column;
    justify-content: flex-end;
    padding: 0;
  }
`;

export const Card = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 2rem;
  max-width: 72rem;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: 4rem ${({ theme }) => theme.spacing.xxl}
    ${({ theme }) => theme.spacing.xxl};
  ${MOBILE} {
    max-width: none;
    border-radius: 2rem 2rem 0 0;
    padding: 3.2rem ${({ theme }) => theme.spacing.lg}
      ${({ theme }) => theme.spacing.xl};
  }
`;

export const CloseButton = styled(CloseButtonBase)`
  position: absolute;
  top: 1.2rem;
  right: 1.6rem;
  font-size: 3.2rem;
`;

export const Heading = styled.h2`
  font-size: 2.6rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  text-align: center;
  margin: 0 0 ${({ theme }) => theme.spacing.sm};
  line-height: 1.2;
`;

export const Subheading = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-align: center;
  margin: 0 0 ${({ theme }) => theme.spacing.xxl};
  line-height: 1.5;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${({ theme }) => theme.spacing.md};

  @media (max-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
  }

  ${MOBILE} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const PersonaCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.4rem;
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing.lg} ${theme.spacing.sm}`};
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  cursor: pointer;
  font-family: inherit;
  transition:
    border-color 0.15s,
    transform 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.accent};
    transform: translateY(-0.2rem);
  }
`;

export const PersonaLabel = styled.span`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
  line-height: 1.3;
`;

export const SkipRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.xl};
`;

export const SkipButton = styled.button`
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.xl}`};
  font-size: 1.5rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.darkSlate};
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: 1.2rem;
  transition:
    border-color 0.15s,
    transform 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.accent};
    transform: translateY(-0.2rem);
  }
`;

export const FilterInput = styled.input`
  width: 100%;
  margin: ${({ theme }) => theme.spacing.md} 0 ${({ theme }) => theme.spacing.lg};
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.md}`};
  font-size: 1.5rem;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.darkSlate};
  background: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.2rem;
  transition: border-color 0.15s;

  &::placeholder {
    color: ${({ theme }) => theme.colors.slateGrey};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.accent};
  }
`;

export const EmptyHint = styled.p`
  margin: ${({ theme }) => theme.spacing.md} 0 0;
  font-size: 1.4rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const ShowAllButton = styled.button`
  display: block;
  margin: ${({ theme }) => theme.spacing.md} auto 0;
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.lg}`};
  font-size: 1.4rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.accentDark};
  background: transparent;
  border: 0.1rem dashed ${({ theme }) => theme.colors.borderStrong};
  border-radius: 999rem;
  transition: border-color 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.accent};
  }
`;
